import React, { Component } from "react";
import BackgroundSlider from 'react-background-slider'

import Headbody from "../../components/head-body";
import Menu from "../../components/menu";
import Devsolucoes from "../../components/dev-solucoes";
import Footer from "../../components/footer";
import Endbody from "../../components/end-body";


import image1 from '../../assets/img/solucoes/img-solucoes_gestao-de-ocupacao.jpg'
import image2 from '../../assets/img/solucoes/img-solucoes_gestao-de-ocupacao-01.jpg'

class Leitoscentrocirurgico extends Component {
  
    render() {
      return (
          <React.Fragment>
                <Headbody></Headbody>
                <Menu></Menu>
                <section class="header-interno padrao">
                  <div class="container">
                    <div class="row">
                      <div class="col-12 col-lg-8">
                        <h2>Itech<span class="azul">Flow</span></h2>
                        <h3>Solução para Gestão de Leitos e Centro Cirúrgico</h3>
                        <span class="saude">Saúde</span>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="conteudo-interno">
                  <div class="container">
                    <div class="row d-lg-flex align-items-lg-center">
                      <div class="col-12 col-lg-6">
                        {/* <div id="galeria" class="owl-carousel">
                          <img src={"../assets/img/solucoes/img-solucoes_gestao-de-ocupacao.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          <img src={"../assets/img/solucoes/img-solucoes_gestao-de-ocupacao-01.jpg"} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img>
                          </div> */}
                          <div style={{width: '480px', height: '400px'}} class="img-fluid m-auto" >
                              <BackgroundSlider
                                  images={[image1, image2]}
                                  duration={5}
                                  transition={0.5}
                              />
                              {/* <img src={image1} class="img-fluid m-auto" alt="Imagem sobre Principais Funcionalidades"></img> */}
                          </div>
                      </div>

                      <div class="col-12 col-lg-6">
                        <h3>Descrição:</h3>
                        {/* <p>O Módulo de Leitos e Centros Cirúrgicos foi desenvolvido com o objetivo de controlar a ocupação em leitos e centros cirúrgicos através da rastreabilidade de pacientes e colaboradores dentro do Hospital. Com essa aplicação conseguimos uma visibilidade completa de todos os eventos que acontecem durante a internação ou cirurgia de determinado paciente. Proporciona maior agilidade para os profissionais de saúde em suas atividades diárias, além disso, identifica todos os eventos de tempos envolvidos no processo.</p> */}
                          <p>O Módulo de Leitos e Centros Cirúrgicos foi desenvolvido com o objetivo de controlar a ocupação em leitos e centros cirúrgicos através da rastreabilidade de pacientes e colaboradores dentro do Hospital. Com essa aplicação conseguimos ter visibilidade completa de todos os eventos que acontecem durante a internação ou cirurgia por paciente. Proporciona maior agilidade para os profissionais de saúde em suas atividades diárias, além disso, identifica todos os eventos de tempos envolvidos no processo.</p>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-12 mt-5">
                        <h3>Aplicação:</h3>
                        <p>Hospitais, e clinicas especializadas</p>

                        <h3>Principais funcionalidades e benefícios:</h3>
                      </div>

                      <div class="col-12 col-md-6">
                        <ul>
                          <li>Facil visualização da ocupação de leitos e centros cirúrgicos em tempo real.</li>
                          <li>Visualização pelo médico da localização do paciente</li>
                          <li>Alertas visuais de ocupação e segurança do paciente;</li>
                          <li>Alertas de acesso do paciente em área nao permitida (COVID)</li>
                          <li>Acionamento automatico da equipe de limpeza pós saida do paciente.</li> 
                          <li>Armazenamento de informações em nuvem sem limite de usuários</li>
                        </ul>
                      </div>

                      <div class="col-12 col-md-6">
                        <ul>
                          <li>SW desenvolvido Web-based (Não requer APP);</li>
                          <li>Todas visualizações são possiveis em Pcs, tablet e smartphone.</li>
                          <li>Interface com dashboard intuitiva e de facil operação: 
                            <ul>
                              <li>Tempo da jornada do paciente,</li>
                              <li>Tempo de uso/ociosidade das salas.</li>
                            </ul>
                          </li>
                          <li>Possibilita aumento da utilização das salas e centros cirurgicos</li>
                          <li>Possibilita aumento da capacidade de atendimento de pacientes;</li>

                        </ul>

                        <br></br><br></br>
                      </div>
                      <div class="col-12 text-center" >
                          <a href={"../pdf/catalogo-centro-cirurgico.pdf"} class="btn-itm" target="_blank">Baixar Catálogo</a>
                          <br></br><br></br>
                      </div>
                    </div>
                  </div>
                </section>

            
                <Devsolucoes></Devsolucoes>
                <Footer></Footer>
                <Endbody></Endbody>
          </React.Fragment>
        
      );
    }
  }

export default Leitoscentrocirurgico;